<!-- Overall / Combined Rating Card — always rendered -->
<!-- <div class="ratings-card mb-4" [class.large-stars]="showLargeStars">
  <h4
    class="card-title"
    [translatable]="{
      transKey: 'events.details.userRatings',
      modEnum: translationModulesEnum
    }"
  >
    {{ "events.details.userRatings" | translate }}({{ attendeeCount || 0 }})
  </h4>

  <div class="stars-display" [attr.aria-label]="(overallRating || 0) + ' out of ' + rateOf + ' stars'">
    <i class="bx bxs-star star filled" *ngFor="let s of fullStars"></i>
    <i class="bx bxs-star-half star filled" *ngIf="hasHalfStar"></i>
    <i class="bx bx-star star empty" *ngFor="let s of emptyStars"></i>
  </div>

  <p
    class="rating-text"
    [translatable]="{
      transKey: 'events.details.outOf',
      modEnum: translationModulesEnum
    }"
  >
    {{ overallRating || 0 }} {{ "events.details.outOf" | translate }} {{ rateOf }}
  </p>

  <div class="breakdown-list">
    <div class="breakdown-row" *ngFor="let row of combinedBreakdown">
      <span
        class="row-label"
        [translatable]="{
          transKey: 'events.details.star',
          modEnum: translationModulesEnum
        }"
      >
        {{ row.star }} {{ "events.details.star" | translate }}
      </span>
      <div
        class="bar-track"
        role="progressbar"
        [attr.aria-valuenow]="row.percentage"
        aria-valuemin="0"
        aria-valuemax="100"
      >
        <div class="bar-fill" [style.width.%]="row.percentage"></div>
      </div>
      <span class="row-pct">{{ row.percentage | number: "1.0-0" }}%</span>
    </div>
  </div>
</div> -->

<!-- Organization Rating Card -->
<div class="ratings-card mb-4" *ngIf="organizationRating?.length">
  <h4
    class="card-title"
    [translatable]="{
      transKey: 'events.details.organizationRating',
      modEnum: translationModulesEnum
    }"
  >
    {{ "events.details.organizationRating" | translate }}
  </h4>

  <div class="breakdown-list">
    <div class="breakdown-row" *ngFor="let row of normalizedOrgRating">
      <span
        class="row-label"
        [translatable]="{
          transKey: 'events.details.star',
          modEnum: translationModulesEnum
        }"
      >
        {{ row.star }} {{ "events.details.star" | translate }}
      </span>
      <div
        class="bar-track"
        role="progressbar"
        [attr.aria-valuenow]="row.percentage"
        aria-valuemin="0"
        aria-valuemax="100"
      >
        <div class="bar-fill" [style.width.%]="row.percentage"></div>
      </div>
      <span class="row-pct">{{ row.percentage | number : "1.0-0" }}%</span>
    </div>
  </div>
</div>

<!-- Activities Rating Card -->
<div class="ratings-card mb-4" *ngIf="activitiesRating?.length">
  <h4
    class="card-title"
    [translatable]="{
      transKey: 'events.details.activitiesRating',
      modEnum: translationModulesEnum
    }"
  >
    {{ "events.details.activitiesRating" | translate }}
  </h4>

  <div class="breakdown-list">
    <div class="breakdown-row" *ngFor="let row of normalizedActivitiesRating">
      <span
        class="row-label"
        [translatable]="{
          transKey: 'events.details.star',
          modEnum: translationModulesEnum
        }"
      >
        {{ row.star }} {{ "events.details.star" | translate }}
      </span>
      <div
        class="bar-track"
        role="progressbar"
        [attr.aria-valuenow]="row.percentage"
        aria-valuemin="0"
        aria-valuemax="100"
      >
        <div class="bar-fill" [style.width.%]="row.percentage"></div>
      </div>
      <span class="row-pct">{{ row.percentage | number : "1.0-0" }}%</span>
    </div>
  </div>
</div>

<!-- User Comments Card -->
<div class="ratings-card mb-4" *ngIf="userComments?.length">
  <h4
    class="card-title"
    [translatable]="{
      transKey: 'events.details.userComments',
      modEnum: translationModulesEnum
    }"
  >
    {{ "events.details.userComments" | translate }}({{
      userRateNotesCount || userComments.length
    }})
  </h4>

  <div class="comments-grid">
    <div
      class="comment-item"
      *ngFor="let c of userComments"
      [attr.dir]="isArabic ? 'rtl' : 'ltr'"
    >
      <span class="comment-author">{{ c.name }}</span>
      <p class="comment-body">{{ c.comment }}</p>
    </div>
  </div>
</div>
